import type { EnvConfig, FleetOverview, OverviewCluster } from "../api/types";

// Promotion trees split into two product lines: Core (core-*) and Integration
// (the IM fleets — im-* on GCP, int_* on AWS). Used to filter the tree view.
export type CanaryCategory = "core" | "integration";

export function canaryCategory(envKey: string): CanaryCategory {
    return envKey.startsWith("core") ? "core" : "integration";
}

export const CATEGORY_LABELS: Record<CanaryCategory, string> = {
    core: "Core",
    integration: "Integration",
};

// The promotion tree spans both server fleets: im-*/int_* (argots) and core clusters
// migrated to ArgoTS (core fleet, state.argots set). Merge for env→cluster lookups.
export function mergeOverviews(argots: FleetOverview | null, core: FleetOverview | null): FleetOverview | null {
    if (!argots || !core) return argots ?? core;
    return { ...argots, clusters: [...argots.clusters, ...core.clusters] }; // alerts are global, not per fleet
}

// Map a promotion env to its cluster row: explicit promotionEnvKey first, then the
// env path basename (envs/<cloud>/im/<name>), then the env key itself.
export function findEnvCluster(
    overview: FleetOverview | null | undefined,
    envKey: string,
    env: EnvConfig | undefined,
): OverviewCluster | undefined {
    if (!overview) return undefined;
    const byKey = overview.clusters.find((c) => c.promotionEnvKey === envKey);
    if (byKey) return byKey;
    const base = env?.path.split("/").filter(Boolean).pop();
    if (base) {
        const byPath = overview.clusters.find((c) => c.cluster === base);
        if (byPath) return byPath;
    }
    return overview.clusters.find((c) => c.cluster === envKey);
}
